/// <reference types="@types/gtag.js"/>
interface MyWindow extends Window {
  gtag: Gtag.Gtag;
}

declare const window: MyWindow;

export default window.gtag;
